import apiClient from "./http";

export const getProfileSettings = () => apiClient.get("/Settings/profile");

export const updateProfileSettings = (payload) =>
  apiClient.put("/Settings/profile", payload);

export const getNotificationSettings = () =>
  apiClient.get("/Settings/notifications");

export const updateNotificationSettings = (payload) =>
  apiClient.put("/Settings/notifications", payload);

export const changePassword = (payload) =>
  apiClient.post("/Settings/security/change-password", payload);
